/*
 * Without the name and id fields, react-admin will delete the name and id from each
 * formPlayer. It looks for fields and then deletes unused data, which we don't want
 * in this case. This gets around that by having the fields on the page, but hiding them
 * from view bc we don't want / need them to be editable.
 */
import React, { Fragment } from "react";
import { TextInput } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  hidden: {
    opacity: "0",
    height: "0",
    width: "0"
  }
});

const SharedPlayerStats = ({ s, children }) => {
  const classes = useStyles();
  return (
    <Fragment>
      {children}
      <TextInput disabled className={classes.hidden} source={s("id")} />
      <TextInput disabled className={classes.hidden} source={s("name")} />
      <TextInput
        label="lastName"
        source={s("lastName")}
        disabled
        className={classes.hidden}
      />
      <TextInput
        label="jerseyNumber"
        source={s("jerseyNumber")}
        disabled
        className={classes.hidden}
      />
    </Fragment>
  );
};

export default SharedPlayerStats;
